import { withStyles, Container } from "@material-ui/core";
import React from "react";
import styles from "./styles";
import { NavLink } from "react-router-dom";
import logo from "../../assets/images/logo.png";
import hotline from "../../assets/images/mobile-hotline.png";
import { FaFacebookF } from "react-icons/fa";
import { FiMapPin, FiPhoneCall, FiMail } from "react-icons/fi";

function Footer(props) {
  const { classes, generalContent } = props;
  
  return (
    <div className={classes.footer}>
      <Container className={classes.container} maxWidth="xl">
        <div>
          <div className={classes.info}>
            <NavLink to="/" title="Về trang chủ">
              <img src={logo} alt="logo" />
            </NavLink>
            <h5>
              Chúng tôi chuyên thiết kế và lập trình website theo yêu cầu của
              khách hàng hỗ trợ đa nền tảng - tối ưu hóa theo chuẩn SEO - phong
              cách hiện đại và giá cả phợp lý !
            </h5>
            <a className="social" href="facebook.com">
              <FaFacebookF />
            </a>
          </div>

          <div className={classes.menu}>
            <h4>THÔNG TIN CHUNG</h4>
            <ul>
              <li>
                <NavLink to="/">Trang chủ</NavLink>
              </li>
              <li>
                <NavLink to="/du-an">Dự án</NavLink>
              </li>
              <li>
                <NavLink to="/tin-tuc">Tin tức</NavLink>
              </li>
              <li>
                <NavLink to="/share">Chia sẻ</NavLink>
              </li>
            </ul>
          </div>

          <div className={classes.menu}>
            <h4>CHÍNH SÁCH CHUNG</h4>
            <ul>
              <li>
                <NavLink to="/about-us">Về chúng tôi</NavLink>
              </li>
              <li>
                <NavLink to="/chinh-sach-thanh-toan">
                  Chính sách thanh toán
                </NavLink>
              </li>
              <li>
                <NavLink to="/chinh-sach-bao-tri">Chính sách bảo trì</NavLink>
              </li>
              <li>
                <NavLink to="/chinh-sach-bao-hanh">Chính sách bảo hành</NavLink>
              </li>
              <li>
                <NavLink to="/contact">Liên hệ</NavLink>
              </li>
            </ul>
          </div>

          <div className={classes.contact}>
            <h4>THÔNG TIN LIÊN HỆ</h4>
            <ul>
              <li>
                <FiMapPin />
                { generalContent.address }
              </li>
              <li>
                <FiPhoneCall />
                { generalContent.phone }
              </li>
              <li>
                <FiPhoneCall />
                0981 210 696
              </li>
              <li>
                <FiMail />
                { generalContent.email }
              </li>
            </ul>
          </div>
        </div>
      </Container>

      <div className={classes.hotlineWarp}>
        <div className="hotline-phone-ring">
            <div className="hotline-phone-ring-circle"></div>
            <div className="hotline-phone-ring-circle-fill"></div>
            <div className="hotline-phone-ring-img-circle">
              <a href="tel:0937692208" className="pps-btn-img">
                  <img src={hotline} alt="Gọi điện thoại" width="50" />
              </a>
            </div>
        </div>
        <div className="hotline-bar">
            <a href="tel:0937692208">
                <span className="text-hotline">093 769 2208</span>
            </a>
        </div>
      </div>      
    </div>
  );
}

export default withStyles(styles)(Footer);
